import React, { useEffect, useState } from 'react';
import { Button, Divider, Space } from 'antd';
import { GoogleOutlined, GithubOutlined } from '@ant-design/icons';
import { useTranslation } from '../i18n';
import authService from '../services/authService';
import { hasUserMode } from '../config/paths';

export const OAUTH_PROVIDERS = [
    { key: 'google', label: 'Google', icon: <GoogleOutlined /> },
    { key: 'github', label: 'GitHub', icon: <GithubOutlined /> },
];

// Reason codes from the API callback (#oauth_error=...) → message.
export const oauthErrorMessage = (reason, t) => {
    switch (reason) {
        case 'cancelled': return t('Sign-in was cancelled');
        case 'email_unverified': return t('No verified email on that account. Sign in with your password, then link it in Settings.');
        case 'link_from_settings': return t('Sign in with your password, then link this account in Settings.');
        case 'identity_taken': return t('This sign-in account is already linked to another user');
        case 'provider_already_bound': return t('An account from this provider is already linked. Unlink it first.');
        case 'account_pending': return t('Your account is awaiting administrator approval');
        case 'account_disabled': return t('This account cannot sign in');
        case 'email_unsupported': return t('This email address cannot be used to sign in');
        case 'email_disposable': return t('Disposable email addresses cannot be used to sign up');
        case 'state_invalid': return t('The sign-in link has expired. Please try again');
        default: return t('Sign-in failed. Please try again');
    }
};

/** Provider buttons for Login/Register; renders nothing when no provider is configured. */
const OAuthButtons = ({ remember = true }) => {
    const { t } = useTranslation();
    const [enabled, setEnabled] = useState({});

    useEffect(() => {
        if (!hasUserMode()) return;
        let alive = true;
        authService.oauthProviders().then((p) => { if (alive) setEnabled(p || {}); });
        return () => { alive = false; };
    }, []);

    const list = OAUTH_PROVIDERS.filter((p) => enabled[p.key]);
    if (list.length === 0) return null;

    return (
        <>
            <Divider plain style={{ margin: '8px 0 16px' }}>{t('or')}</Divider>
            <Space direction="vertical" style={{ width: '100%', marginBottom: 16 }}>
                {list.map((p) => (
                    <Button
                        key={p.key}
                        block
                        icon={p.icon}
                        onClick={() => { window.location.href = authService.oauthStartUrl(p.key, remember); }}
                    >
                        {t('Continue with {{provider}}', { provider: p.label })}
                    </Button>
                ))}
            </Space>
        </>
    );
};

export default OAuthButtons;
